import { render, staticRenderFns } from "./ShadowAttrsItem.vue?vue&type=template&id=b10b6bda&"
import script from "./ShadowAttrsItem.vue?vue&type=script&lang=js&"
export * from "./ShadowAttrsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/attr/items/ShadowAttrsItem.vue"
export default component.exports